<template>
  <div>
    <div class="page-error-info" v-if="pageError">
      <p>您的简历状态已更新，无法再选择培训，请联系HR确认培训安排。</p>
    </div>
    <div v-else class="train-confirm-main-wrapper">
      <p class="title">身份信息</p>
      <van-field
        v-model="name"
        name="姓名"
        label="姓名"
        placeholder="姓名"
        class="train-confirm-field"
        readonly
      />
      <van-field
        v-model="tel"
        type="tel"
        name="联系电话"
        label="联系电话"
        class="train-confirm-field"
        placeholder="联系电话"
        readonly
      />
      <van-field
        v-if="isCoach"
        v-model="registerPhone"
        type="tel"
        name="注册手机号"
        label="注册手机号"
        class="train-confirm-field"
        placeholder="猿辅导注册手机号"
      />

      <p class="title">培训信息</p>
      <van-field label="是否参加培训" class="train-confirm-field">
        <template #input>
          <a-radio-group v-model="isAttend">
            <a-radio :value="true">参加</a-radio>
            <a-radio :value="false">不参加</a-radio>
          </a-radio-group>
        </template>
      </van-field>
      <div v-if="isAttend">
        <van-field
          label="选择培训场次"
          label-class=" train-select-label"
          class="train-confirm-field"
          readonly
        >
        </van-field>
        <div class="train-list-wrapper">
          <div class="empty" v-if="!trainList.length">
            没有可选择的培训，请联系HR
          </div>
          <train-item
            v-else
            v-for="train in trainList"
            :trainData="train"
            :selected="selectedId === train.id"
            :key="train.id"
            @change="selectedChange"
          ></train-item>
        </div>
      </div>
      <div style="padding: 16px;">
        <a-button
          type="primary"
          shape="round"
          class="confirm-button"
          @click="submit"
          :disabled="isAttend && !selectedId"
          >确认</a-button
        >
      </div>
      <a-modal
        title="确认选择"
        :visible="attendModalVisible"
        :closable="false"
        wrapClassName="garden-modal-wrap"
        @ok="attend"
        @cancel="attendModalClose"
      >
        <train-details-in-modal
          :trainData="selectTrainData"
        ></train-details-in-modal>
      </a-modal>
    </div>
  </div>
</template>
<script>
import TrainItem from './TrainItem'
import TrainDetailsInModal from './TrainDetailsInModal'
import { routerNamePrefix } from './router'
import { updateFeedback } from '@/service/trainConfirm'
import { getcandidateBasicInfo } from '@/service/common'
import {
  NOT_FEEDBACK,
  FEEDBACK_MODIFIABLE,
  FEEDBACK_NON_MODIFIABLE,
} from './const'

export default {
  components: { TrainItem, TrainDetailsInModal },
  data() {
    return {
      registerPhone: undefined,
      isAttend: true,
      selectedId: null,
      attendModalVisible: false,
      attendLoading: false,
      notAttendLoading: false,
      pageError: false,
    }
  },
  computed: {
    isCoach() {
      return this.$route.query.dept === 'tutor'
    },
    srId() {
      return (
        this.$route.query.srId ||
        (this.$store.state.candidateInfo &&
          this.$store.state.candidateInfo.srId)
      )
    },
    name() {
      return (
        this.$store.state.candidateInfo && this.$store.state.candidateInfo.name
      )
    },
    tel() {
      return (
        this.$store.state.candidateInfo && this.$store.state.candidateInfo.phone
      )
    },
    trainList() {
      return this.$store.state.trainConfirm.trainList
    },
    selectTrainData() {
      return this.trainList.filter(train => train.id === this.selectedId)[0]
    },
  },
  async created() {
    await this.getCndidateInfo()
    const { candidateInfo } = this.$store.state
    if (candidateInfo.status !== '待安排培训') {
      this.pageError = true
    } else {
      const { feedback } = this.$store.state.trainConfirm
      const { status, trainingId } = feedback
      const urlFrom = this.$route.query.from
      if (
        (status === FEEDBACK_MODIFIABLE && urlFrom === 'result') ||
        status === NOT_FEEDBACK
      ) {
        // 反馈可修改 && 从结果页跳转过来
        this.$store.dispatch('trainConfirm/getTrainList', {
          srId: this.$route.query.srId,
        })
        this.getInitStatus()
      } else {
        // 不可修改 || 可修改不是从结果页跳转
        if (trainingId) {
          this.$router.push({
            name: `${routerNamePrefix}_success`,
            query: this.$route.query,
          })
        } else {
          this.$router.push({
            name: `${routerNamePrefix}_notAttend`,
            query: this.$route.query,
          })
        }
      }
    }
  },
  mounted() {
    this.frogReport('/event/gardenTraining/pageView')
  },
  methods: {
    async getCndidateInfo() {
      const { srId, dept } = this.$route.query
      let res = await getcandidateBasicInfo(srId)
      const candidateInfo = { ...res, dept, srId }
      this.$store.commit('setCandidateInfo', candidateInfo)
      this.$store.commit('trainConfirm/setFeedback', { ...res.feedback })
    },
    getInitStatus() {
      const { feedback } = this.$store.state.trainConfirm
      if (
        [FEEDBACK_MODIFIABLE, FEEDBACK_NON_MODIFIABLE].includes(feedback.status)
      ) {
        this.isAttend = Number(feedback.trainingId) !== 0
        this.selectedId = feedback.trainingId
      }
    },
    selectedChange(value) {
      this.selectedId = value
    },
    submit() {
      if (this.isAttend) {
        const { trainingId } = this.$store.state.trainConfirm.feedback
        if (trainingId === this.selectedId) {
          this.duplicate()
        } else {
          this.attendConfirm()
        }
      } else {
        this.notAttendConfirm()
      }
    },
    duplicate() {
      this.$info({
        title: '重新选择的培训不可以和之前的保持一致，请重新选择',
        okText: '重选',
        cancelButtonProps: { style: 'color:#fff' },
        class: 'garden-modal-wrap',
        centered: true,
        autoFocusButton: null,
      })
    },
    attendConfirm() {
      this.attendModalVisible = true
    },
    async attend() {
      this.attendLoading = true
      await updateFeedback(this.srId, this.selectedId, this.registerPhone)
      this.updateFeedbackStore(this.selectedId)
      this.submissionFrog()
      this.attendLoading = true
      this.attendModalVisible = false
      this.$router.push({
        name: `${routerNamePrefix}_success`,
        query: this.$route.query,
      })
    },
    attendModalClose() {
      this.attendModalVisible = false
    },
    notAttendConfirm() {
      const self = this
      this.$confirm({
        title: '你确定不参加岗前培训吗？',
        onOk() {
          self.notAttend()
        },
        class: 'garden-modal-wrap',
        centered: true,
        icon: 'bul',
        autoFocusButton: null,
      })
    },
    async notAttend() {
      this.notAttendLoading = true
      await updateFeedback(this.srId, 0)
      this.updateFeedbackStore(0)
      this.notAttendLoading = false
      this.submissionFrog()
      this.$router.push({
        name: `${routerNamePrefix}_notAttend`,
        query: this.$route.query,
      })
    },
    frogReport(url, extra = []) {
      this.$addFrog(1531, url, [
        { key: 'submitresumeid', value: this.srId },
        ...extra,
      ])
    },
    updateFeedbackStore(trainingId) {
      const { status } = this.$store.state.trainConfirm.feedback
      let nextStatus = ''
      switch (status) {
        case NOT_FEEDBACK:
          nextStatus = FEEDBACK_MODIFIABLE
          break
        case FEEDBACK_MODIFIABLE:
          nextStatus = FEEDBACK_NON_MODIFIABLE
          break
        default:
          nextStatus = FEEDBACK_NON_MODIFIABLE
          break
      }
      this.$store.commit('trainConfirm/setFeedback', {
        ...this.$store.state.trainConfirm.feedback,
        status: nextStatus,
        trainingId,
      })
    },
    submissionFrog() {
      const { status } = this.$store.state.trainConfirm.feedback
      const ditail =
        status === FEEDBACK_MODIFIABLE
          ? 'firstTimeSubmission'
          : 'secondSubmission'
      this.frogReport(`/event/gardenTraining/${ditail}`)
    },
  },
}
</script>
<style lang="less" scoped>
.train-confirm-main-wrapper {
  background: #f0f2f5;
  height: 100vh;
  & > .title {
    padding: 16px 0 8px 12px;
    font-size: 14px;
    color: rgba(92, 92, 92, 1);
    line-height: 20px;
    margin-bottom: 0;
  }
  .train-list-wrapper {
    background: #fff;
    overflow: hidden;
    .empty {
      height: 100px;
      text-align: center;
      line-height: 100px;
      color: #cecfd4;
    }
  }
}
</style>
<style lang="less">
.train-confirm-field {
  .van-field__label {
    width: 116px;
  }
}
</style>
